module.exports = __webpack_public_path__ + "static/media/award_img.3c645d8e.png";